import { clx } from 'Utils';
import styles from 'partials/card/subscription-card.module.scss';
import { FC } from 'react';

// Inline skeleton style
const skeletonStyle: React.CSSProperties = {
	display: 'inline-block',
	background: '#f2f2f4',
	borderRadius: 4,
	minHeight: 16,
	minWidth: 80,
	width: '100px',
	height: '16px',
	animation: 'skeleton-loading 1.2s infinite ease-in-out'
};

const skeletonKeyframes = `
@keyframes skeleton-loading {
	0% { opacity: 1; }
	50% { opacity: 0.4; }
	100% { opacity: 1; }
}
`;

export const SkeletonVoucherDetails: FC = () => {
	const row_class = 'justify-content-between';
	return (
		<div>
			<style>{skeletonKeyframes}</style>
			<h6 className="text-gray-3 mb-3 fs-6 fw-400">
				<span style={skeletonStyle} />
			</h6>
			{[1, 2, 3, 4, 5, 6].map((item) => {
				return (
					<div key={item} className={clx(styles.row, row_class)}>
						<span className={clx(styles.rowLabel, 'fw-500')}>
							<span style={skeletonStyle} />
						</span>
						<span className="fw-500">
							<span style={skeletonStyle} />
						</span>
					</div>
				);
			})}
		</div>
	);
};
